import React, { useEffect, useState } from 'react';
import { Box, TextField, Typography } from '@mui/material';
import Add from '@mui/icons-material/Add';
import Modal from '../../../components/Modal/Modal';
import { AppButton } from '../../../components/UI';

const AddTypeDocumentDialog = ({ open, onClose, onAddType, existingNames = [] }) => {
  const [newTypeName, setNewTypeName] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) { setNewTypeName(''); setError(''); }
  }, [open]);

  const handleConfirmAdd = async () => {
    const name = newTypeName.trim();
    if (!name) { setError('Le nom du type ne peut pas être vide.'); return; }
    if (existingNames.some((n) => String(n).trim().toLowerCase() === name.toLowerCase())) {
      setError('Ce type de document existe déjà.');
      return;
    }
    setSaving(true);
    try {
      await onAddType(name);
      onClose();
    } catch (e) {
      setError("Erreur lors de l'ajout du type de document.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={saving ? undefined : onClose}
      title="Nouveau type de document"
      maxWidth="xs"
      actions={(
        <>
          <AppButton variant="secondary" onClick={onClose} disabled={saving}>Annuler</AppButton>
          <AppButton variant="primary" onClick={handleConfirmAdd} loading={saving} startIcon={<Add fontSize="small" />}>Ajouter</AppButton>
        </>
      )}
    >
      <Box component="form" onSubmit={(e) => { e.preventDefault(); handleConfirmAdd(); }}>
        <Typography sx={{ fontSize: '0.72rem', fontWeight: 700, color: error ? '#dc2626' : '#334155', letterSpacing: '0.06em', textTransform: 'uppercase', mb: 0.75 }}>
          Nom du type <Box component="span" sx={{ color: '#dc2626' }}>*</Box>
        </Typography>
        <TextField
          autoFocus
          fullWidth
          size="small"
          autoComplete="off"
          placeholder="Ex : CIN, Passeport, RIB, Contrat signé…"
          value={newTypeName}
          onChange={(e) => { setNewTypeName(e.target.value); setError(''); }}
          error={!!error}
          sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
        />
        <Typography sx={{ fontSize: '0.76rem', color: error ? '#dc2626' : '#94a3b8', mt: 0.75 }}>
          {error || 'Il pourra ensuite être associé à un ou plusieurs types de contrat.'}
        </Typography>
      </Box>
    </Modal>
  );
};

export default AddTypeDocumentDialog;
